export default "/_next/static/images/sparkle-icon-6e8ddf13dd93b8127ef6da266a59e3e5.svg";